import { Button, Form, Input, Radio, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { Status } from '../service';

const StyledForm = styled(Form<CreateAdminFormValues>)`
  .ant-form-item-label {
    font-weight: 500;
  }
`;

export interface CreateAdminFormValues {
  email: string;
  first_name: string;
  last_name: string;
  role: 'root_admin' | 'tenant_admin';
  tenant_id?: string;
  status: Status;
}

interface CreateAdminFormProps {
  onSubmit: (values: CreateAdminFormValues) => Promise<void>;
  onCancel: () => void;
  onReset: () => void;
  submitting: boolean;
}

const CreateAdminForm: React.FC<CreateAdminFormProps> = ({
  onSubmit,
  onCancel,
  onReset,
  submitting,
}) => {
  const [form] = Form.useForm<CreateAdminFormValues>();
  const [role, setRole] = React.useState<'root_admin' | 'tenant_admin'>('root_admin');

  return (
    <StyledForm
      form={form}
      layout="vertical"
      onFinish={onSubmit}
      initialValues={{
        role: 'root_admin',
        status: 'active',
      }}
    >
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: 'Please input email!' },
          { type: 'email', message: 'Please enter a valid email!' }
        ]}
      >
        <Input placeholder="Enter email address" />
      </Form.Item>

      <Form.Item
        label="First Name"
        name="first_name"
        rules={[{ required: true, message: 'Please input first name!' }]}
      >
        <Input placeholder="Enter first name" />
      </Form.Item>

      <Form.Item
        label="Last Name"
        name="last_name"
        rules={[{ required: true, message: 'Please input last name!' }]}
      >
        <Input placeholder="Enter last name" />
      </Form.Item>

      <Form.Item
        label="Role"
        name="role"
        rules={[{ required: true, message: 'Please select role!' }]}
      >
        <Radio.Group onChange={(e) => setRole(e.target.value)}>
          <Radio value="root_admin">Root Admin</Radio>
          <Radio value="tenant_admin">Tenant Admin</Radio>
        </Radio.Group>
      </Form.Item>

      {role === 'tenant_admin' && (
        <Form.Item
          label="Tenant ID"
          name="tenant_id"
          rules={[{ required: true, message: 'Please input tenant ID!' }]}
        >
          <Input placeholder="Enter tenant ID" />
        </Form.Item>
      )}

      <Form.Item
        label="Status"
        name="status"
        rules={[{ required: true, message: 'Please select status!' }]}
      >
        <Radio.Group>
          <Radio value="active">Active</Radio>
          <Radio value="inactive">Inactive</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item style={{ marginTop: 24, marginBottom: 0, textAlign: 'right' }}>
        <Space>
          <Button onClick={onReset}>Reset</Button>
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={submitting}>
            Create
          </Button>
        </Space>
      </Form.Item>
    </StyledForm>
  );
};

export default CreateAdminForm; 